module.exports = __webpack_public_path__ + "static/media/sopasycremas_checked.4015149b.svg";